import { recordsApi } from "shared/api/recordsApi";

export const cancelPaymentRequest = (recordId) => {
  return recordsApi.cancelPayment(recordId);
};
